import {
  ToggleButton,
  ToggleButtonGroup,
  type ToggleButtonGroupProps,
} from '@mui/material'
import { useSearch } from '@/features/search/hooks/useSearch'
import { useAppSelector } from '@/redux/hooks'

export const SpecialSearches = () => {
  const { selectors, setSearchType } = useSearch()
  const searchType = useAppSelector(selectors.selectSearchType)

  const handleChange: ToggleButtonGroupProps['onChange'] = (_event, value) => {
    setSearchType(value)
    if (value === null) setSearchType('recent')
  }

  return (
    <ToggleButtonGroup
      exclusive
      value={searchType}
      size="large"
      onChange={handleChange}
      color="info"
      sx={{ height: 56 }}
    >
      <ToggleButton value="recent">Recently Viewed</ToggleButton>
    </ToggleButtonGroup>
  )
}
